// ----------------------------------------------------------------------------
// Copyright (c) Ben Coleman, 2020
// Licensed under the MIT License.
//
// Set of methods to call the Graph API, using REST and fetch
// ----------------------------------------------------------------------------

import auth from './auth'

const GRAPH_BASE = 'https://graph.microsoft.com/v1.0'
const GRAPH_SCOPES = [ 'user.readwrite.all','sites.readwrite.all','calendars.readwrite','files.readwrite.all','directory.readwrite.all', 'group.readwrite.all','sites.fullcontrol.all' ]

let accessToken

export default {
  //
  // Get details of user, and return as JSON
  // https://docs.microsoft.com/en-us/graph/api/user-get?view=graph-rest-1.0&tabs=http#response-1
  //
  async getSelf() {
    let resp = await callGraph('/me')
    if (resp) {
      let data = await resp.json()
      console.log(data)
      return data
    }
  },

  //
  // Get user's photo and return as a blob object URL
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  //
  async getPhoto() {
    let resp = await callGraph('/me/photos/240x240/$value')
    if (resp) {
      let blob = await resp.blob()
      return URL.createObjectURL(blob)
    }
  },

  async getSingleFile(groupId, itemId) {
    let resp = await callGraph("/groups/" + groupId + "/drive/items/" + itemId)
    if (resp) {
      let data = await resp.json()
      console.log(data)
      return data
    }
  },

    async getThumbnails(groupId, itemId) {
    let resp = await callGraph(`/groups/${groupId}/drive/items/${itemId}/thumbnails`)
    if (resp) {
      let data = await resp.json()
      return data
    }
  },

  async getFileChildren(groupId, itemId) {
    let resp = await callGraph("/groups/" + groupId + "/drive/items/" + itemId+"/children?$expand=thumbnails")
    if (resp) {
      let data = await resp.json()
      console.log(data)
      return data
    }
  },

  async checkFolderContainsFile(groupId, itemId, search_name) {
    
    let resp = await callGraph(`/groups/${groupId}/drive/items/${itemId}/children?$filter=startswith(name,'${search_name}')`);
    if (resp) {
      console.log("Found searched files by name", resp)
      let data = await resp.json()
      return data
    }
  },


  //
  // Search for users
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  //
  async searchUsers(searchString, max = 50) {
    let resp = await callGraph(`/users?$filter=startswith(displayName, '${searchString}') or startswith(userPrincipalName, '${searchString}')&$top=${max}`)
    if (resp) {
      let data = await resp.json()
      return data
    }
  },

  //
  // Accessor for access token, only included for demo purposes
  //
  getAccessToken() {
    return accessToken
  }
}

//
// Common fetch wrapper (private)
//
async function callGraph(apiPath) {
  // Acquire an access token to call APIs (like Graph)
  // Safe to call repeatedly as MSAL caches tokens locally
  accessToken = await auth.acquireToken(GRAPH_SCOPES)

  let resp = await fetch(
    `${GRAPH_BASE}${apiPath}`,
    {
      headers: { authorization: `bearer ${accessToken}` }
    }
  )

  if (!resp.ok) { throw new Error(`Call to ${GRAPH_BASE}${apiPath} failed: ${resp.statusText}`) }

  return resp
}